/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_CitiesInputs */

const en_directory_search_cities = /** @type {(inputs: Directory_Search_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cities`)
};

const pl_directory_search_cities = /** @type {(inputs: Directory_Search_CitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miasta`)
};

/**
* | output |
* | --- |
* | "Cities" |
*
* @param {Directory_Search_CitiesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_cities = /** @type {((inputs?: Directory_Search_CitiesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_CitiesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_cities(inputs)
	return en_directory_search_cities(inputs)
});